import AuthorizationHelper from '@auth/services/authorization.helper';
import ModulesHelper from '@core/services/modules.helper';

const routes = [
  {
    path: 'activities',
    name: 'admin-activities',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
      module: ModulesHelper.ACTIVITIES_MODULE_NAME,
    },

    component: () =>
      import(/* webpackChunkName: "admin-activities" */ '@activities/pages/activity/activity.vue'),
  },
  {
    path: 'club-activities',
    name: 'admin-club-activities',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
      module: ModulesHelper.ACTIVITIES_MODULE_NAME,
    },

    component: () =>
      import(/* webpackChunkName: "admin-activities" */ '@activities/pages/club-activities.vue'),
  },
  {
    path: 'activity-groups',
    name: 'admin-activity-groups',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.activity_groups],
      module: ModulesHelper.ACTIVITIES_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-activity-groups" */ '@activities/pages/activity-groups/activity-groups.vue'
      ),
  },
  {
    path: 'activity-sessions',
    name: 'admin-activity-sessions',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.activity_sessions],
      module: ModulesHelper.ACTIVITIES_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-activity-sessions" */ '@activities/pages/activity-sessions/activity-sessions.vue'
      ),
  },
  {
    path: 'activity-session-attendees',
    name: 'admin-activity-session-attendees',
    exact: false,
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.activity_session_attendees],
      module: ModulesHelper.ACTIVITIES_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-activity-session-attendee-wrapper" */ '@activities/pages/activity-session-attendee-wrapper/activity-session-attendee-wrapper.vue'
      ),
    children: [
      {
        name: 'admin-activity-session-attendees',
        path: 'activity-session-attendees',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
          module: ModulesHelper.ACTIVITIES_MODULE_NAME,
        },
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "admin-activity-session-attendees" */ '@activities/pages/activity-session-attendees/activity-session-attendees.vue'
          ),
      },
      {
        name: 'admin-activity-session-waiting-contacts',
        path: 'activity-session-waiting-contacts',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
          module: ModulesHelper.ACTIVITIES_MODULE_NAME,
        },
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "admin-activity-session-waiting-attendees" */ '@activities/pages/activity-session-waiting-contacts/activity-session-waiting-contacts.vue'
          ),
      },
    ],
  },
  {
    path: 'enrollments',
    name: 'admin-enrollments',
    exact: false,
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.enrollments],
      module: ModulesHelper.ACTIVITIES_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-enrollments-wrapper" */ '@activities/pages/enrollment-wrapper/enrollment-wrapper.vue'
      ),
    children: [
      {
        name: 'admin-enrollments',
        path: 'enrollments',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
          module: ModulesHelper.ACTIVITIES_MODULE_NAME,
        },
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "admin-enrollments" */ '@activities/pages/enrollment/enrollment.vue'
          ),
      },
      {
        name: 'admin-waiting-list',
        path: 'waiting-list',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
          module: ModulesHelper.ACTIVITIES_MODULE_NAME,
        },
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "admin-enrollments" */ '@activities/pages/enrollment/enrollment.vue'
          ),
      },
    ],
  },
  {
    path: 'activity-categories',
    name: 'admin-activity-categories',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.activity_categories],
      module: ModulesHelper.ACTIVITIES_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-activity-categories" */ '@activities/pages/activity-categories/activity-categories.vue'
      ),
  },
  {
    path: 'enrollments/payments-follow-up',
    name: 'admin-enrollments-payments-follow-up',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
      module: ModulesHelper.ACTIVITIES_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-enrollments-payments-follow-up" */ '@activities/pages/enrollment-payment-follow-up.vue'
      ),
  },
  {
    name: 'admin-activities-manage',
    path: 'activities/:id',
    meta: {
      layout: 'bpc-admin',
      withSidebar: false,
      //TODO: check permisions
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
      module: ModulesHelper.ACTIVITIES_MODULE_NAME,
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "admin-activities-manage" */ '@activities/pages/activity-management-v2/activity-management-v2.vue'
      ),
    children: [
      {
        name: 'admin-activity-group-management',
        path: 'group/:activity_group_id',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
          module: ModulesHelper.ACTIVITIES_MODULE_NAME,
        },
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "admin-enrollment-container" */ '@activities/components/containers/enrollment-container.vue'
          ),
      },
    ],
  },
  {
    path: 'club-trainings',
    name: 'admin-club-trainings',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
      module: ModulesHelper.ACTIVITIES_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-club-trainings" */ '@activities/pages/club-trainings.vue'),
  },
  {
    path: 'club-trainings/:id',
    name: 'admin-club-trainings-management',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
      module: ModulesHelper.ACTIVITIES_MODULE_NAME,
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "admin-club-trainings" */ '@activities/pages/activity-management-v2/activity-management-v2.vue'
      ),
  },
  {
    path: 'club-competitions',
    name: 'admin-club-competitions',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
      module: ModulesHelper.ACTIVITIES_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-club-competitions" */ '@activities/pages/club-competitions.vue'
      ),
  },
  {
    path: 'club-competitions/:id',
    name: 'admin-club-competitions-management',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
      module: ModulesHelper.ACTIVITIES_MODULE_NAME,
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "admin-club-trainings" */ '@activities/pages/activity-management-v2/activity-management-v2.vue'
      ),
  },
  {
    path: 'club-courses',
    name: 'admin-club-courses',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
      module: ModulesHelper.ACTIVITIES_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-club-courses" */ '@activities/pages/club-courses.vue'),
  },
  {
    path: 'club-activity-calendar',
    name: 'admin-club-activity-calendar',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
      module: ModulesHelper.ACTIVITIES_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-club-courses" */ '@activities/pages/club-activity-calendar.vue'
      ),
  },
];

export const publicActivitiesRoutes = [
  {
    path: 'activity-details/:alias',
    name: 'public-activity-details',
    meta: {
      layout: 'bpc-public',
      publicRoute: true,
      entity: 'activity',
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "public-activity-details" */ '@activities/pages/public-activity-details/public-activity-details.vue'
      ),
    children: [
      {
        path: 'posts/:postId',
        name: 'public-activity-details-post',
        meta: {
          layout: 'bpc-public',
          publicRoute: true,
          // withSidebar: true,
          // originShowContact: false
        },
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "public-activity-details" */ '@activities/pages/public-activity-details/public-activity-details.vue'
          ),
      },
    ],
  },
];
export const publicSummonsRoutes = [
  {
    path: 'summon/:attendeeId/:answer/:token',
    name: 'public-activity-summons-answer',
    meta: {
      layout: 'bpc-userpages',
      publicRoute: true,
      entity: 'activity-session-attendee',
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "public-activity-summons-answer" */ '@activities/pages/public-summons-answer/public-summons-answer.vue'
      ),
  },
];

export default routes;
